import { useMutation } from "@tanstack/react-query";
import { useApi } from "hooks/useApi";

type UploadParameters = {
  file: File;
};

const useUploadPersonImage = () => {
  const callApi = useApi();

  return useMutation({
    mutationFn: async ({ file }: UploadParameters) => {
      const pathsResponse = await callApi(`/storage/persons/images/upload-url/${file.name}`, { method: "POST" });
      const { uploadUrl, filePath } = pathsResponse?.data?.[0] || {};

      if (!uploadUrl || !filePath) {
        return "";
      }

      // upload to S3
      await fetch(uploadUrl, {
        method: "PUT",
        body: file,
        headers: { "Content-Type": file.type || "application/octet-stream" },
      });

      return filePath;
    },
  });
};

export default useUploadPersonImage;
